import { useContext } from 'react'
import { GlobalSearchContext } from '../context/GlobalSearchContext'
import useGoBackState from 'shared/hooks/useGoBackState'
import { Chip, GlobalSearch, IconBoardwork } from '@bbl-digital/snorre-v2'

export const BoardMeetingSearchHits = () => {
  const { loading, boardMeetingHits } = useContext(GlobalSearchContext)
  const { push } = useGoBackState()

  const hasBoardMeetingHits = boardMeetingHits?.hits?.length

  const goToBoardCase = (id: string) => {
    push(`/styrearbeid/moter/saker/${id}`)
  }

  const chipVariantForStatus: Record<
    string,
    'warning' | 'success' | 'outline' | 'error'
  > = {
    Utsatt: 'warning',
    Avsluttet: 'success',
    Opprettet: 'outline',
    Slettet: 'error',
  }

  if (loading || !hasBoardMeetingHits) return null

  const Hits = () => {
    return boardMeetingHits.hits?.map((item) => (
      <GlobalSearch.Item
        key={item.id}
        label={item.title}
        subtitle={item.description}
        highlights={item.highlights || []}
        icon={<IconBoardwork backgrounded colorVariant="primary" />}
        options={{
          renderHighlightsAsHtml: true,
        }}
        chip={
          item.caseStatus ? (
            <Chip
              label={item.caseStatus}
              variant={chipVariantForStatus[item.caseStatus] || 'primary'}
            />
          ) : undefined
        }
        onClick={() => goToBoardCase(item.id)}
      />
    ))
  }

  return (
    <GlobalSearch.Group label="Styremøtesaker" title="Styremøtesaker">
      <Hits />
    </GlobalSearch.Group>
  )
}
